import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

// IMPORTACIÓN ESTÁTICA DE RECURSOS (SOLUCIÓN NUCLEAR)
// Garantiza que los archivos estén en el bundle JS final, eliminando errores de carga asíncrona.
import en from './locales/en.json';
import es from './locales/es.json';
import ca from './locales/ca.json';

console.log('[i18n] 🚀 Initializing with STATIC resources (v25+ Nuclear Setup) - FORCED ES');

const resources = {
  en: { translation: en },
  es: { translation: es },
  ca: { translation: ca }
};

i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es', // FORZADO AHORA
    fallbackLng: 'en',
    
    // Configuración explícita para evitar conflictos
    ns: ['translation'],
    defaultNS: 'translation',
    
    interpolation: {
      escapeValue: false, // React protege contra XSS por defecto
    },
    
    react: {
      useSuspense: false, // CRÍTICO: Desactivamos Suspense porque los datos ya están en memoria
    },
    
    // Debug para verificar en consola del navegador
    debug: true,
    
    // Asegurar compatibilidad con estructuras JSON anidadas
    keySeparator: '.', 
    
    // Evitar que devuelva objetos si falta una key (devuelve la key)
    returnObjects: true, 
  });

console.log('[i18n] ✅ Configuration complete. Current language:', i18next.language);

export default i18next;
